import React, { useEffect, useState } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import { Loader } from "sulu-admin-bundle/components";
import Matches from "../components/TeamDragger/Matches";
import Teams from "../components/TeamDragger/Teams";
import {
  createGuidId,
  formatDataToSend,
  groupBy,
  reorderRows,
} from "../utils/teams-dragger";

const portal = document.createElement("div");
portal.classList.add("dragger-portal");

if (!document.body) {
  throw new Error("body not ready for portal creation!");
}

document.body.appendChild(portal);

const TeamsDragger = ({ ...props }) => {
  // console.log({ props });

  const {
    data: { league_planning },
  } = props;

  const [loading, setLoading] = useState(true);
  const [boardData, setBoardData] = useState([]);

  useEffect(() => {
    const teamsCol = league_planning?.teams?.$mobx?.values || [];
    const matchesCol = [];

    league_planning?.matchdays?.$mobx?.values?.forEach((t) => {
      const m = [];
      t?.matches?.$mobx?.values?.forEach((mc) => {
        m.push({
          home: mc?.home,
          away: mc?.away,
          datetime: mc?.datetime,
        });
      });

      matchesCol.push({
        ...t,
        date: t?.date,
        matches: m,
      });
    });

    //
    const locale = props.router.attributes.locale;
    const api_url = props.schemaOptions?.["api_url"]?.value;

    async function fetchData() {
      const res = await fetch(
        `${api_url}?locale=${locale}&ids=${teamsCol.join(",")}`
      );

      const data = await res.json();

      const dhbteam = data?._embedded?.dhbteam || [];
      const dhbmatches = [];

      matchesCol?.forEach((t, tIndex) => {
        t?.matches.forEach((match, i) => {
          const items = [];
          const home = dhbteam.find((t) => t?.id === match?.home);
          const away = dhbteam.find((t) => t?.id === match?.away);

          if (home) {
            items.push({
              ...home,
              index: 0,
            });
          }

          if (away) {
            items.push({
              ...away,
              index: 1,
            });
          }

          dhbmatches.push({
            id: createGuidId(),
            identifier: t?.date + "*" + tIndex,
            colType: "matches",
            // date: new Date(t?.date),
            // time: new Date(match?.datetime),
            // date: t?.date ? new Date(t?.date) : null,
            // time: match?.datetime ? new Date(match?.datetime) : null,
            date: t?.date,
            time: match?.datetime,
            items: items,
          });
        });
      });

      const dhbteams = [
        {
          id: "teams",
          identifier: "teams",
          colType: "teams",
          items: dhbteam,
        },
      ];

      setBoardData([...dhbteams, ...dhbmatches]);
      setLoading(false);
    }

    if (api_url && locale) {
      fetchData();
    }

    return () => {};
  }, []);

  const onDragEnd = ({
    destination,
    source,
    draggableId,
    mode,
    reason,
    type,
    combine,
  }) => {
    if (!destination) {
      return;
    }
    if (source.droppableId === "teams" && destination.droppableId === "teams") {
      return;
    }

    if (source.droppableId !== "teams" && destination.droppableId === "teams") {
      return;
    }

    setBoardData((rows) => {
      const newRows = reorderRows({
        rows,
        destination,
        source,
        draggableId,
        mode,
        reason,
        type,
        combine,
      });

      const newData = formatDataToSend(newRows);
      props.onChange(newData);
      props.onFinish();
      return newRows;
    });
  };

  if (loading) {
    return <Loader size={50} />;
  }

  if (!boardData.find((r) => r.colType === "teams")?.items?.length) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <p>No Teams defined</p>;
      </div>
    );
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="dragger">
        <Teams boardData={boardData} portal={portal} />
        <Matches
          onChange={props.onChange}
          onFinish={props.onFinish}
          boardData={boardData}
          setBoardData={setBoardData}
          portal={portal}
        />
      </div>
    </DragDropContext>
  );
};

export default TeamsDragger;
